// /plan — today's session card, this week, run arc, non-negotiables.

import { createFileRoute } from '@tanstack/react-router';
import { DesktopPage } from '../components/ledger/DesktopPage';
import { PlanPage, PlanScreen } from '../components/ledger/PlanPage';
import { useIsDesktop } from '../lib/useMediaQuery';

function PlanRoute() {
  const desktop = useIsDesktop();
  if (!desktop) return <PlanScreen />;
  return (
    <DesktopPage inspector="coach">
      <PlanPage />
    </DesktopPage>
  );
}

export const Route = createFileRoute('/plan')({ component: PlanRoute });
